import React from 'react'
import '../Styles/Footer.css'

const Footer = () => {
  return (
    <footer className="footer flex">
      {
        window.location.href === 'http://localhost:3000/' ?
          <ul className="flex">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="#Skills">Skills</a>
            </li>
            <li>
              <a href="/Main">Projects</a>
            </li>
            <li>
              <a style={{ display: 'flex' }} href="#Contact-Me">Contact <span style={{ marginLeft: '5px' }}>Me</span>  </a>
            </li>

          </ul>                                            :
          <ul className="flex">
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/">Skills</a>
          </li>
          <li>
            <a href="/Main">Projects</a>
          </li>
          <li>
            <a style={{ display: 'flex' }} href="/">Contact <span style={{ marginLeft: '5px' }}>Me</span>  </a>
          </li>
        </ul>
      }



      <div className="all-icons flex">
        <div className="icon icon-twitter"></div>
        <a href="https://www.instagram.com/a_m_i_n_e__aa/">
          <div className="icon icon-instagram"></div>
        </a>
        <a href='https://github.com/AminEaabada?tab=repositories' >
          <div className="icon icon-github"></div>
        </a>
        {/* <div className="icon icon-linkedin"></div> */}
      </div>
      <p>© 2023 Aabada Amine. All rights reserved.</p>
    </footer>
  );
};

export default Footer;

